import { TypedUseSelectorHook, useSelector } from 'react-redux';
import {ROOT_STATE} from '../state';

export const useTypedSelector: TypedUseSelectorHook<ROOT_STATE> = useSelector;